// extracted by mini-css-extract-plugin
export default {"page-header":"ListingHeader_page-header__QKnNB","page-header__text":"ListingHeader_page-header__text__3jXe0"};